import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { DataService } from 'src/app/services/data.service';
import { UserService } from 'src/app/services/user.service';

@Injectable()
export class ClaimEditResolver  {
  constructor(
    private userService: UserService,
    private dataService: DataService
  ) {
  }
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if((this.userService.isDDCommerceGuardUser() || this.userService.isBundledClaimUser()) && this.userService.getUserInfo()?.trackingNumber) {
      let shipmentData = JSON.parse(sessionStorage.getItem('shipmentData'));
      if (shipmentData) {
        return of(shipmentData);
      }
      else {
        return this.dataService.gatherShipmentDetails(this.userService.getUserInfo()?.trackingNumber).pipe(
          tap((res) => {
            sessionStorage.setItem('shipmentData', JSON.stringify(res.data));
          })
        );
      }
    }
    else {
      return of(true);
    }
  }
}
